import { defineStore } from 'pinia'
import { SegmentEditorItem } from '@/models/SegmentEditorItem'

export const mergeStore = defineStore('mergeStore', {
    state: () => ({
        segmentId: 0,
        mergeSegmentsCount: 2,
        maxMergeSegmentsCount: 2,
        mergeArray: [] as number[],
        continuationSegments: [] as SegmentEditorItem[],
        continuationHasMore: false,
        continuationLoading: false,
        continuationChecked: false,
        isAtParagraphEnd: false,
        hasMoreSegments: true,
    }),

    getters: {
        canIncrease: (state) => {
            const totalAvailable = state.maxMergeSegmentsCount + state.continuationSegments.length;
            return state.mergeSegmentsCount < totalAvailable ||
                !state.continuationChecked ||
                state.continuationHasMore;
        },
        canDecrease: (state) => state.mergeSegmentsCount > 2,
        totalAvailableSegments: (state) => {
            return state.maxMergeSegmentsCount + state.continuationSegments.length;
        },
    },

    actions: {
        init() {
            this.segmentId = 0;
            this.mergeSegmentsCount = 2;
            this.maxMergeSegmentsCount = 2;
            this.mergeArray = [];
            this.isAtParagraphEnd = false;
            this.hasMoreSegments = true;
            this.clearContinuation();
        },

        setSegmentId(id: number) {
            this.segmentId = id;
        },

        setMaxMergeSegmentsCount(count: number) {
            this.maxMergeSegmentsCount = count;
        },

        setMergeArray(array: number[]) {
            this.mergeArray = array;
        },

        increaseMergeSegmentsCount() {
            const totalAvailable = this.maxMergeSegmentsCount + this.continuationSegments.length;
            if (this.mergeSegmentsCount >= totalAvailable && !this.continuationHasMore) {
                return false;
            }
            this.mergeSegmentsCount++;
            return true;
        },

        decreaseMergeSegmentsCount() {
            if (this.mergeSegmentsCount <= 2) {
                return false;
            }
            this.mergeSegmentsCount--;
            return true;
        },

        setContinuationSegments(segments: SegmentEditorItem[], hasMore: boolean) {
            this.continuationSegments = segments;
            this.continuationHasMore = hasMore;
            this.continuationChecked = true;
        },

        appendContinuationSegments(segments: SegmentEditorItem[], hasMore: boolean) {
            this.continuationSegments.push(...segments);
            this.continuationHasMore = hasMore;
            this.continuationChecked = true;
        },

        setContinuationLoading(loading: boolean) {
            this.continuationLoading = loading;
        },

        setContinuationHasMore(hasMore: boolean) {
            this.continuationHasMore = hasMore;
        },

        setContinuationChecked(checked: boolean) {
            this.continuationChecked = checked;
        },

        setAtParagraphEnd(value: boolean) {
            this.isAtParagraphEnd = value;
        },

        setHasMoreSegments(value: boolean) {
            this.hasMoreSegments = value;
        },

        clearContinuation() {
            this.continuationSegments = [];
            this.continuationHasMore = false;
            this.continuationLoading = false;
            this.continuationChecked = false;
        },
    }
})